import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { YodaColors, YodaBorderRadius } from 'yoda-ui/yodaTheme';

export const contentCardStyle: SxProps<Theme> = {
  border: 'none',
  padding: '24px',
  boxShadow: `0px 5px 20px ${YodaColors.gray2}`,
  overflow: 'visible',
  borderRadius: YodaBorderRadius.medium,
};
